module.exports = __webpack_public_path__ + "static/media/turntable.842473ab.svg";